import { FormControl, Select } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

const ITEM_HEIGHT = 32
const ITEM_PADDING_TOP = 8
const VISIBLE_ITEMS = 5

export const CategoryMenuProps = {
  PaperProps: {
    sx: {
      background: theme.colors.legacyBackgroundDark,
      boxShadow: theme.attributes.boxShadow.selectFieldPaper,
      borderRadius: theme.attributes.borderRadius.small,
      minWidth: '130px',

      '.MuiMenuItem-root': {
        height: '32px',
        paddingLeft: `${theme.spacing.small}px`,
        paddingRight: `${theme.spacing.small}px`,
        display: 'flex',
        alignItems: 'center',
        width: '100%',

        img: {
          marginRight: `${theme.spacing.xSmall}px`
        },

        '&:hover': {
          background: `${theme.colors.legacyAlpha3} !important`,

          '.MuiListItemText-root .MuiTypography-root': {
            color: theme.colors.cta
          }
        },

        '.MuiCheckbox-root': {
          paddingRight: '19px',
          paddingLeft: 0,

          svg: {
            path: {
              fill: theme.colors.calendarDay
            }
          }
        },

        '.MuiListItemText-root .MuiTypography-root': {
          fontFamily: theme.typography.fontFamily.primary,
          fontWeight: theme.typography.fontWeight.normal,
          fontSize: theme.typography.fontSize.large,
          lineHeight: '20px',
          letterSpacing: '0.25px',
          color: theme.colors.btnSecondaryText
        },

        '&.Mui-selected': {
          background: theme.colors.menuItemHover
        },

        '&[aria-selected="true"]': {
          '.MuiListItemText-root .MuiTypography-root': {
            color: theme.colors.cta
          }
        },

        '.image-wrapper': {
          display: 'flex',

          '> img': {
            width: '18px',
            height: '18px',
            boxShadow: theme.attributes.boxShadow.chipCircle,
            margin: '-4.5px',
            borderRadius: theme.attributes.borderRadius.circle,

            '&:nth-of-type(1)': {
              zIndex: 10
            },
            '&:nth-of-type(2)': {
              zIndex: 9
            },
            '&:nth-of-type(3)': {
              zIndex: 8
            },
            '&:nth-of-type(4)': {
              zIndex: 7
            },
            '&:nth-of-type(5)': {
              zIndex: 6
            },
            '&:nth-of-type(6)': {
              zIndex: 5
            },
            '&:nth-of-type(7)': {
              zIndex: 4
            }
          }
        },

        '.textWrapper': {
          marginLeft: '13px'
        }
      },

      '&::-webkit-scrollbar': {
        width: '4px',
        background: 'transparent'
      },

      '&::-webkit-scrollbar-track': {
        boxShadow: 'none',
        background: 'transparent'
      },

      '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme.colors.legacyTextPrimary2,
        borderRadius: theme.attributes.borderRadius.secondary,
        "html[data-theme='light'] &": {
          backgroundColor: theme.colors.dropdownBorder
        }
      }
    },
    style: {
      // MenuList's own 8px top padding is what ITEM_PADDING_TOP absorbs, so 5 rows land uncropped
      maxHeight: ITEM_HEIGHT * VISIBLE_ITEMS + ITEM_PADDING_TOP
    }
  },
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'left' as const
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'left' as const
  },
  variant: 'menu' as const,
  getContentAnchorEl: null
}

export const BenchmarkingSelect = styled(Select)<{ isselected?: string; noborder?: string }>`
  width: 158px;
  height: 48px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 14px 16px;
  cursor: pointer;
  color: ${theme.colors.legacyNeutral};
  font-family: ${theme.typography.fontFamily.primary};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  border-radius: 12px;
  border: 1px solid ${theme.colors.legacyTextPrimary2};
  background: ${theme.colors.legacyPrimaryDarker};

  .MuiSelect-select {
    padding: 0 !important;
    min-width: 0 !important;
    width: auto !important;
    text-align: center;
    color: ${theme.colors.cta} !important;
    -webkit-text-fill-color: ${theme.colors.cta} !important;
  }

  .MuiSelect-icon {
    position: static !important;
    margin: 0 !important;
    flex-shrink: 0;
    cursor: pointer;
  }

  ${({ isselected }) =>
    isselected === 'true' &&
    `
    background: rgba(208, 188, 255, 0.16);
  `};

  > * {
    border: none !important;
    outline: none !important;
  }

  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border: none !important;
    background: ${theme.colors.legacyPrimaryDarker};
  }

  &.Mui-disabled {
    .MuiSelect-outlined {
      -webkit-text-fill-color: rgba(255, 255, 255, 0.6) !important;
    }
  }

  svg {
    path {
      stroke: ${theme.colors.textSecondary};
      fill: none;
    }
  }
`

export const BenchmarkingFormControl = styled(FormControl)`
  border-radius: 12px;
  border: none;
  outline: none;
  width: 158px;
  height: 48px;
  margin-bottom: ${theme.spacing.medium}px;

  .MuiSelect-icon {
    top: calc(50% - 0.7em);
  }
`
